import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import CardSlider from '../CardSlider/CardSlider'
import Icon from '../../ui/Icon/Icon'

import media from '../../../services/generateMediaQueries'

const StyledCardSlider = styled(CardSlider)`
  .slick-slide {
    /* width: 100%; */
    margin-right: 15px;
  }
  .slick-list {
    /* max-width: 600px; */
  }
  overflow: hidden;
`

const ImageSliderWrapper = styled.div`
  position: relative;
`

const SliderWrapper = styled.div`
  /* width: 100%; */
`

const ButtonNavWrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;

  ${media.lessThan('large')`
    display: none;
  `}
`

const ButtonNav = styled.button`
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  outline: none;
  margin-right: 0.5rem;
  border: 1px solid var(--color-fg-lighter);
  font-size: 1.8rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-fg-lighter);
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  & > svg {
    margin-top: -5px;
    margin-left: ${props => (props.right ? 0 : '-5px')};
    margin-right: ${props => (props.right ? '-5px' : 0)};
  }

  :last-child {
    margin-right: 0;
  }

  :hover {
    background: var(--color-primary-hover);
    border-color: transparent;
    color: white;
    transition: all var(--animation-duration) var(--animation-easing);
  }

  :focus {
    border-color: var(--color-primary);
    transition: all var(--animation-duration) var(--animation-easing);
  }
`

const MallImage = styled.div.attrs(props =>
  props.photo
    ? {
        style: {
          background: `url('${props.photo.url}') no-repeat center / cover`,
        },
      }
    : {},
)`
  width: 400px !important;
  height: 400px;
  max-height: 400px;

  ${media.lessThan('small')`
    width: 200px !important;
    height: 200px;
    max-height: 200px;
  `}
`

const DescriptionWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  ${media.lessThan('small')`
    flex-direction: column;
  `}
`

const MallIcon = styled.img`
  width: 120px;
  max-height: 120px;
  margin-right: 20px;
  margin-bottom: 20px;
`

const MallDescription = styled.div`
  flex-grow: 1;
`

const Section = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid var(--color-fg-light);

  ${props =>
    props.border === 0 &&
    css`
      padding-top: 0;
      border: none;
    `}
`

const SectionTitle = styled.h2`
  margin-top: 0;
  font-family: var(--font-family-ayala-display-sans);
`

const SectionLabel = styled.label``

const SectionDescription = styled.p`
  margin: 0;
`

const SectionDescriptionWrapper = styled.div``

const SectionGridContainer = styled.div`
  display: flex;
  margin-bottom: 5px;

  ${SectionLabel} {
    flex: 1 1;
    padding-right: 10px;
  }

  ${SectionDescriptionWrapper} {
    flex: 1 1 160px;
  }
`

const ToggleMalls = styled.a`
  color: var(--color-primary);
  cursor: pointer;

  ${media.greaterThan('small')`
    display: none;
  `}
`

class OurMallsContent extends React.Component {
  mallImageSlider = React.createRef()

  mallImageSliderNext = () => {
    this.mallImageSlider.current.slickNext()
  }

  mallImageSliderPrev = () => {
    this.mallImageSlider.current.slickPrev()
  }

  render() {
    const { onToggleSideBar, data: currentMall } = this.props

    const placeholderImage =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkrgcAAIsAhFyQqocAAAAASUVORK5CYII='

    return (
      <>
        <Section border={0}>
          {!!onToggleSideBar && (
            <ToggleMalls onClick={onToggleSideBar}>Our Malls</ToggleMalls>
          )}
          <SectionTitle>{currentMall.name}</SectionTitle>
          <DescriptionWrapper>
            {currentMall.logoUrl && (
              <MallIcon
                src={
                  currentMall.logoUrl.includes('string') || !currentMall.logoUrl
                    ? placeholderImage
                    : currentMall.logoUrl
                }
              />
            )}
            {currentMall.description && (
              <MallDescription
                dangerouslySetInnerHTML={{
                  __html: currentMall.description,
                }}
              />
            )}
          </DescriptionWrapper>
        </Section>
        {!!currentMall.photos && !!currentMall.photos.length && (
          <ImageSliderWrapper>
            <SliderWrapper>
              <StyledCardSlider
                key={currentMall.id}
                ref={this.mallImageSlider}
                dataSource={currentMall.photos}
                renderItem={item => (
                  <MallImage
                    key={item}
                    src={
                      item.url.includes('string') || !item.url
                        ? placeholderImage
                        : item.url
                    }
                    photo={item}
                  />
                )}
              />
            </SliderWrapper>
            {currentMall.photos.length > 1 && (
              <ButtonNavWrapper>
                <ButtonNav onClick={this.mallImageSliderPrev}>
                  <Icon name="slide-left" />
                </ButtonNav>
                <ButtonNav onClick={this.mallImageSliderNext} right>
                  <Icon name="slide-right" />
                </ButtonNav>
              </ButtonNavWrapper>
            )}
          </ImageSliderWrapper>
        )}
        <Section>
          <SectionTitle>Address</SectionTitle>
          <p>{currentMall.address}</p>
        </Section>
        {currentMall.sections &&
          currentMall.sections
            .filter(section => section.labels.length)
            .map(section => (
              <Section key={section.id}>
                <SectionTitle>{section.name}</SectionTitle>
                {section.labels.map(label => (
                  <SectionGridContainer key={label.id}>
                    <SectionLabel>{label.value}</SectionLabel>
                    {label.details.length > 0 && (
                      <SectionDescriptionWrapper>
                        {label.details.map(detail => (
                          <SectionDescription
                            key={`${section.id}-${label.id}-${detail.id}`}
                          >
                            {detail}
                          </SectionDescription>
                        ))}
                      </SectionDescriptionWrapper>
                    )}
                  </SectionGridContainer>
                ))}
              </Section>
            ))}
      </>
    )
  }
}

OurMallsContent.defaultProps = {
  data: {},
}

OurMallsContent.propTypes = {
  data: PropTypes.shape({}),
  onToggleSideBar: PropTypes.func,
}

export default OurMallsContent
